// Cluster 02-B/C — AI suitability letter (COBS 9A) + consistency check.
export default {
  title: 'AI suitability letter',
  generate: 'Generate AI suitability letter',
  generateCaption:
    'Drafts a COBS 9A suitability letter from the facts recorded on this case ' +
    '(risk assessment, planning objectives, investment goals and any recorded ' +
    'vulnerability). You review, edit and approve it — nothing is sent to the client.',
  generating: 'Generating the suitability draft — this usually takes under a minute…',
  generateFailed: 'The draft could not be generated.',
  generateFailedCaption: 'No advice content was produced. You can try again.',
  draftTitle: 'Draft suitability letter',
  draftBadge: 'AI draft — not approved',
  approvedBadge: 'Approved',
  editCaption:
    'This is an AI-generated draft. Review and edit it before approving — you remain ' +
    'responsible for the advice (COBS 9A).',
  approve: 'Approve draft',
  approveCaption:
    'Approval records your name and the time against this draft. It does not send ' +
    'anything to the client.',
  approvedCaption:
    'Approved. Attach it to the pack as a PDF (it sits below the cover note), ' +
    'then send the pack with the existing “Send Recommendation Pack” button.',
  attachToPack: 'Attach to pack as PDF',
  attachedToPack: 'Suitability letter attached to the pack as a PDF.',
  consistency: {
    title: 'Consistency check',
  },
  vulnerabilityEcho: {
    label: 'Vulnerability status (FG21/1):',
    noneRecorded: 'None recorded for this case — the draft assumed no vulnerability.',
    vulnerable: 'Recorded as vulnerable — the draft adapts to the recorded drivers.',
    notVulnerable: 'Assessed — no vulnerability recorded.',
  },
};
